import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useVideo, useVideoDispatch } from "../providers/VideoContext";
import { usePlatformStore } from "@platform/store";
import { videoEventBus } from "../videoEventBus";
import { getMeetingDetails } from "../utils/api/getMeetingDetails";
import { MeetingDetails } from "../types/video.types";

export function useMeetingDetailsOnly() {
  const { meetingId, roomId, roomAccess, isVerifyingRoomAccess, roomAccessError, lastHeartbeat, userName, meetingDetails, isFetchingMeetingDetails, meetingDetailsError } = useVideo();
  const dispatch = useVideoDispatch();
  const user = usePlatformStore((s) => s.user);
  const { meetingId: meetingIdFromUrl } = useParams();

  const fetchMeetingDetails = useCallback(async (meetingId: string) => {
    if (!user) return;

    try {
      dispatch({
        type: "video/set/fetchingMeetingDetails",
        payload: { isFetchingMeetingDetails: true },
      });

      const details = await getMeetingDetails(meetingId);
      
      dispatch({
        type: "video/set/meetingDetails",
        payload: { meetingDetails: details },
      });

      dispatch({
        type: "video/set/fetchingMeetingDetails",
        payload: { isFetchingMeetingDetails: false },
      });

      return details;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Failed to fetch meeting details";
      
      dispatch({
        type: "video/set/meetingDetailsError",
        payload: { meetingDetailsError: errorMessage },
      });

      dispatch({
        type: "video/set/fetchingMeetingDetails",
        payload: { isFetchingMeetingDetails: false },
      });

      throw error;
    }
  }, [user, dispatch]);

  return {
    meetingId,
    roomId,
    roomAccess,
    isVerifyingRoomAccess,
    roomAccessError,
    lastHeartbeat,
    userName,
    meetingDetails,
    isFetchingMeetingDetails,
    meetingDetailsError,
    fetchMeetingDetails,
  };
}
